// @core/api/endpoints/document/delete_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/document';

/**
 * Delete pipeline
 * Archives a pipeline template. Active executions are not affected.
 */
export async function DeletePipeline(
  pipeline_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-pipelines/:pipeline_id`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
